import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[chat-host]',
})
export class ChatDirective {
  constructor(public viewContainerRef: ViewContainerRef) { }
}